// @flow
import ContrastColorUpdater from "../../helper/ContrastColorUpdater";
import useThemeStylesheet from "../../hooks/useThemeStylesheet";

const BmwmoTheme = props => {
    useThemeStylesheet(() => import("./bmwmo.lazy.scss"));
    return <>
	<ContrastColorUpdater/>
	{props.children}
    </>;
};

export default BmwmoTheme;
